module.exports = __webpack_public_path__ + "538504fe4f70334b06100c35fb4e372d.svg";